import { Component, EventEmitter, Input, Output, OnInit, OnChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonModelService } from '../../../../padu-reporting/capability/common-model.service';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import { ENTER } from '@angular/cdk/keycodes';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatSelect, MatOption } from '@angular/material/select';
import { MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MultiselectGroupCheckboxComponent } from '../../../../shared/elements/multiselect-group-checkbox/multiselect-group-checkbox.component';

@Component({
    selector: 'app-add-role-popup',
    templateUrl: './add-role-popup.component.html',
    styleUrl: './add-role-popup.component.css',
    imports: [FormsModule, MatFormField, MatSelect, MatOption, MatChipGrid, MatChipRow, MatIcon, MatChipRemove, MatAutocompleteTrigger, MatChipInput, MatAutocomplete, MultiselectGroupCheckboxComponent]
})
export class AddRolePopupComponent implements OnChanges, OnInit {
  @Input() hierarchyDropdownConfig;
  @Input() lobdropdwnDataSource;
  @Input() selectedInitiative: any;
  @Input() clearFormFields: boolean = false;
  @Output() emitReqPayload: EventEmitter<any> = new EventEmitter();
  @Input() tabledata: any;
  reqPayload: any;
  private subject: Subject<string> = new Subject();
  inputElement: any;
  users: any[];
  selectedUsers: any = {};
  roleDropdownList: any;
  roleaccessDtl: any = {};
  setlobSublobToAll: boolean;
  seglobsubLob: any;
  role: any;
  clearAllSelection: boolean = false;
  selectValues = [];
  disableMultiSelect: boolean = false;
  separatorKeysCodes: number[] = [ENTER];
  disableItems: any;
  constructor(public maintenanceService: MaintenanceService, private capabilityService: CommonModelService,) {

  }
  ngOnInit(): void {
    this.selectedUsers = {};
    this.getRoleDrpdwnLst();
    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchObj => {
      this.handleSearch(searchObj);
    });
  }

  ngOnChanges() {
    if (this.clearFormFields) {
      this.clearFields();
    }
  }

  getRoleDrpdwnLst() {
    const payload = {
      "initiativeID": this.selectedInitiative.initiative_ID
    };
    this.maintenanceService.getEIRoles(payload).subscribe((response) => {
      if (response && response.roles?.length > 0) {
        this.roleaccessDtl = response;
        this.roleDropdownList = response.roles;
      } else {
        this.roleDropdownList = [];
      }
    });
  }
  keyUpSearch(name) {
    const p: any = {}
    p['search'] = name.target.value;
    this.inputElement = name;
    if (name.target.value) {
      this.subject.next(p);
    }
    else {
      this.users = [];
    }
  }

  selected(event) {
    this.disableItems = [];
    if (event.option.value.givenName !== '') {
      this.selectedUsers = event.option.value;
      if (this.inputElement) {
        this.inputElement.target.value = '';
        this.users = []
      }
      this.checkDisability();

    }
  }

  checkDisability() {
    if (this.disableMultiSelect) {
      return;
    }
  
    const filteredItems = this.getUserRoleMatches();
    this.updateSubLobDisableStates(filteredItems);
  }
  
  private getUserRoleMatches(): any[] {
    return this.tabledata.filter(x => 
      x.MSId === this.selectedUsers.MSId && x.Role === this.role
    );
  }
  
  private updateSubLobDisableStates(filteredItems: any[]): void {
    this.lobdropdwnDataSource.forEach(segment => {
      this.processSegmentLobs(segment, filteredItems);
    });
  }
  
  private processSegmentLobs(segment: any, filteredItems: any[]): void {
    segment.lob.forEach(eachlob => {
      this.processLobSubLobs(eachlob, filteredItems);
    });
  }
  
  private processLobSubLobs(lob: any, filteredItems: any[]): void {
    lob.subLob.forEach(element => {
      element.disable = this.shouldDisableSubLob(element, filteredItems);
    });
  }
  
  private shouldDisableSubLob(subLob: any, filteredItems: any[]): boolean {
    if (filteredItems.length === 0) {
      return false;
    }
    return filteredItems.findIndex(x => x.subLobID === subLob.SubLobID) >= 0;
  }

  roleSelected(role) {
    this.setlobSublobToAll = false;
    if (this.roleaccessDtl.Full_Access_Role.includes(role)) {
      this.selectValues = this.getAllSubLOB();
      this.disableMultiSelect = true;
    } else {
      this.selectValues = [];
      this.disableMultiSelect = false;
    }
    this.selectedUsers = {};
  }

  getAllSubLOB() {
    const allSUBLOB = [];
    this.lobdropdwnDataSource.forEach(segment => {
      segment.lob.forEach(eachlob => {
        eachlob.subLob.forEach(item => {
          allSUBLOB.push(item.SubLobID)
        })
      })
    });
    return allSUBLOB;
  }

  remove() {
    this.selectedUsers = {};
    this.checkDisability();
  }
  checkexist(user) {
    if (this.disableMultiSelect) {
      const userhasaccessalready = this.tabledata.filter(x => x.MSId == user.MSId && x.Role == this.role);
      return userhasaccessalready.length > 0 ? true : false;
    }

  }

  handleSearch(searchObj) {
    const value = searchObj['search'];
    const column = searchObj['column'];
    if (value) {
      this.capabilityService.getLDAPUsers(value).subscribe(dataStream => {
        this.users = [];
        dataStream.forEach(element => {
          this.users.push({
            givenName: element.givenName,
            sn: element.sn,
            mail: element.mail,
            displayName: element.displayName,
            employeeID: element.employeeID,
            MSId: element.cn,
            middleName: element.middleName,
          });
        });
      }, (error) => {
        console.error(error);
      });
    } else {
      column.options = [];
    }
  }
  selectedHierarchy(data) {
    this.seglobsubLob = data;
  }
  disableSubmit() {
    return (this.role && (this.seglobsubLob && this.seglobsubLob.length > 0) && (this.selectedUsers &&this.selectedUsers.givenName )? false : true);
  }
  submitForm() {
    const reqPayload = {
      "add": {},
      "remove": {}
    }
    reqPayload.add = {
      "initiative_id": this.selectedInitiative.initiative_ID,
      "role": this.role,
      "data": this.seglobsubLob,
      "names": []
    }
    reqPayload.add['names'].push(this.selectedUsers);
    if (this.disableMultiSelect) {
      const selectedLOBSUBLOb = [
        {
          "lob": "All",
          "sublob": ["All"]
        }];
      reqPayload.add['data'] = selectedLOBSUBLOb;
    }
    this.emitReqPayload.emit(reqPayload);
    this.clearFields();
  }
  clearFields() {
    this.role = ""
    this.seglobsubLob = [];
    this.selectedUsers = '';
    this.clearFormFields = false;
    this.selectValues = [];
    this.disableMultiSelect = false;
  }

}

